export default __webpack_public_path__ + "static/media/save.1551f54f.svg";